import { SVGS } from '~/assets/assetsPath';
import config from '~/config';

export const navCardAboutMe = [
    {
        id: 1,
        icon: SVGS.IconPeople,
        iconActive: SVGS.IconPeopleSelected,
        text: 'Personal information',
        path: config.routes.profile,
        children: [
            {
                id: 11,
                text: 'Profile',
                path: config.routes.profile,
            },
            {
                id: 12,
                text: 'Change password',
                path: config.routes.changePass,
            },
        ],
    },
    {
        id: 2,
        icon: SVGS.IconWallet,
        iconActive: SVGS.IconWalletSelected,
        text: 'My wallet',
        path: config.routes.topUp,
        children: [
            {
                id: 21,
                text: 'Deposit',
                path: config.routes.topUp,
            },
            {
                id: 22,
                text: 'Withdraw money',
                path: config.routes.withdraw,
            },
            {
                id: 23,
                text: 'Transaction history',
                path: config.routes.historyTopUp,
            },
            {
                id: 24,
                text: 'Withdrawal history',
                path: config.routes.historyWithdraw,
            },
        ],
    },
    {
        id: 3,
        icon: SVGS.IconCard,
        iconActive: SVGS.IconCardSelected,
        text: 'My card',
        path: config.routes.card,
        children: [
            {
                id: 31,
                text: 'My tags',
                path: config.routes.card,
            },
            {
                id: 32,
                text: 'Card user',
                path: config.routes.useCard,
            },
        ],
    },
    {
        id: 4,
        icon: SVGS.IconBill,
        iconActive: SVGS.IconBillSelected,
        text: 'Order',
        path: config.routes.orders,
        children: [],
    },
    {
        id: 5,
        icon: SVGS.IconSchedule,
        iconActive: SVGS.IconScheduleSelected,
        text: 'Schedule history',
        path: config.routes.historyBooking,
        children: [],
    },
    {
        id: 6,
        icon: SVGS.IconDownLineCollab,
        iconActive: SVGS.IconDownLineCollabSelected,
        text: 'Collaborator',
        path: config.routes.downLineCollab,
        children: [],
    },
    {
        id: 7,
        icon: SVGS.IconQRCode,
        iconActive: SVGS.IconQRCodeSelected,
        text: 'my QR',
        path: config.routes.shareCollab,
        children: [],
    },
];
